import { Grid } from '@material-ui/core'
import { CheckboxInput } from 'src/packages/g10-components/CheckboxInput'

interface Props {
  prefix?: string
}

export const DadosLote = (props: Props) => {
  const prefix = props.prefix ? `config.${props.prefix}` : 'config'

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.codigo`} label="Código" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.descricao`} label="Descrição" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.operacaoKMM`} label="Operação KMM" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.filialPC`} label="Filial PC" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.numeroPC`} label="Numero PC" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.status`} label="Status" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.numeroPedido`}
          label="Número do Pedido"
        />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.freteEmpresa`} label="Frete Empresa" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.freteSubcontratadoPJ`}
          label="Frete Subcontratado PJ"
        />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.freteSubcontratadoPF`}
          label="Frete Subcontratado PF"
        />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.quantidadeRetirada`}
          label="Quantidade Retirada"
        />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.quantidadeTotal`} label="Quantidade" />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.saldo`} label="Saldo" />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.dataInicio`}
          label="Data Início Retirada"
        />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.dataTermino`}
          label="Data Término Retirada"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.tipoContratacao`}
          label="Tipo de Contratação"
        />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.especie`} label="Espécie" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.emailCriador`} label="Criador" />
      </Grid>
      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.analistaResponsavel`}
          label="Responsável"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.previsaoMargem`}
          label="Previsão de Margem"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.filialEmissao`}
          label="Filial Emissao"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.pagadorTomador`}
          label="Pagador/Tomador"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.enderecoPagadorTomador`}
          label="Endereço Pagador/Tomador"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.remetente`} label="Remetente" />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.enderecoRemetente`}
          label="Endereço Remetente"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.destinatario`} label="Destinatario" />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.enderecoDestinatario`}
          label="Endereço Destinatario"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.localColeta`} label="Local Coleta" />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.enderecoLocalColeta`}
          label="Endereço Local Coleta"
        />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput name={`${prefix}.localEntrega`} label="Local Entrega" />
      </Grid>

      <Grid item xs={3}>
        <CheckboxInput
          name={`${prefix}.enderecoLocalEntrega`}
          label="Endereço Local Entrega"
        />
      </Grid>
    </Grid>
  )
}
